import React, { Component } from 'react';

class SectionBreakBar extends Component {

  render() {
    return (
      <div style={{ height: "4rem", backgroundColor: "#5b616a"}}></div>
    );
  }

}

export default SectionBreakBar;
